import { Component, OnInit, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { TableData } from '../md/md-table/md-table.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { UserService } from '../services/user.service';
import { User } from '../models/user';
import { CompanylinkedService } from '../services/companylinked.service';
import { InternalLocationservice } from '../services/internallocation.service';
import { CompanyLinked } from '../models/companylinked';
import { Holydays } from '../models/holydays';
import { HolidaysService } from '../services/holidays.service';
import { Methods } from '../shared/methods';
import swal from 'sweetalert2';
import { TitleService } from '../services/title.service';

import { Title } from "@angular/platform-browser";

declare const require: any;

declare const $: any;

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}

@Component({
    selector: 'app-profile-cmp',
    templateUrl: 'profile.component.html',
    providers: [UserService,  CompanylinkedService, HolidaysService, InternalLocationservice],
    styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit, AfterViewInit {
  public mtds: Methods = new Methods();
  public identity;
  public token;
  public privilegio;
  public internallocationList;
  public tableVisitas: DataTable;
  public internallocationname = ""
  public loading;

  public visitas;
  public holydays: Holydays;
  public idPaciente;

  public statusHolyday: any = null;
  public user;
  public idManager;
  public emailManager = 'loading';
  public action = 'create';
  public phoneManager = '...';
  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public order = 0;
  public cargando = false;
  public guardando = false;
  public searchString;
  public status_user;
  public companies: Array<CompanyLinked>;
  public companySelected;
  public urlProfilePic = 'https://www.datalus.mx/projects/liposser/resources/uploads/default-avatar.png';
  public loadingHd = false;
  public savingHd = false;
  public hdID = null;
  public hdAvailability = true;
  public holydasy: string[][];
    sexos = [
      {value: 1, viewValue: 'Male'},
      {value: 0, viewValue: 'Female'}
    ];

     constructor(public dialog: MatDialog, private _userService: UserService,
      private _companylinkedService: CompanylinkedService,
      private _route: ActivatedRoute,
      private _router: Router, private titleService: Title,
      private _internalLocationservice: InternalLocationservice,
      private _hdServices: HolidaysService,private titleServices: TitleService) {
        this.titleService.setTitle("Profile");
        this.token = this._userService.getToken();
        this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
        this.identity = this._userService.getIdentity();
        this.idPaciente = this.identity.sub;

      if  (this.identity == null) {
        localStorage.clear();
        this._router.navigate(['/pages/lock']);
      } else {
   /*      this.getHolydays(); */
      }
      this.getCompanies();
      this.user = {
        name: 'loading',
        surname: '...',
        location: {id: 0},
        internalLocation: {id: 0}
      };
  }

     ngOnInit() {

     if (this.identity == null && this.identity.sub){
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    } else {
      console.log('ngOnInit');
      this.getUser();
      /* this.getHolydays(); */
    }
    this.getCompanies();

/*     if(this.user.role != 'VENDOR' && this.user.role != 'customer'){
      this.getHolydays();
    } */
    this.holydays = new Holydays(this.identity.sub);
    this.titleServices.setTitle('Profile');
  }

  endHD() {
    $( '#hdModal' ).modal( 'hide' );
    this.hdID = null;
    this.action = 'create';
    this.guardando = false;
    this.cargando = false;
  }

  valid(f) {
    if (!f.valid || !this.hdAvailability) {
      return false;
    }

    return true;
  }

/*   changewhloc(){
  this._internalLocationservice.onlylinkedlocations(this.user.location.id).subscribe(
              response => {
                console.log(response);
                this.internallocationList = response.data;
              });
} */


  saveHD() {
    this.guardando = true;
    let json;
    json = {
      // user_id: this.idUser,
      TypeCheck: 'HOLIDAY',
      // holidayStartDate: this.hdStart,
      // holidayEndDate: this.hdEnd,
      // comments: this.hdComments
    };

    switch (this.action) {
      case 'create': {
        this._hdServices.create(json).subscribe(
          response => {
            if (response.status === 'success') {
              this.endHD();
              swal.fire({
             
                title: 'Holiday added successfully!',
                text: '',
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
              });
            } else {
              this.guardando = false;
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.guardando = false;
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
        break;
      }
      case 'update': {
        this._hdServices.update(json, this.hdID).subscribe(
          response => {
            if (response.status === 'success') {
              this.endHD();
          /*     this.getHolydays(); */
              swal.fire({
              
                title: 'Holiday updated successfully!',
                text: '',
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
              });
            } else {
              this.guardando = false;
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.guardando = false;
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
        break;
      }
      case 'delete': {
        this._hdServices.delete(this.hdID).subscribe(
          response => {
            if (response.status === 'success') {
              this.endHD();
           /*    this.getHolydays(); */
              swal.fire({
             
                title: 'Holiday has ben remove successfully!',
                text: '',
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
              });
            } else {
              this.guardando = false;
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.guardando = false;
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
        break;
      }
    }

  }

  boton(e) {
    console.log(e);
    switch (e.evento) {
      case 'show': {
        break;
      }
      case 'delete': {
        this.hdID = e.row[0];
        this.openHD('delete');
        break;
      }
    }
  }

  openHD(action = 'create') {
    $( '#hdModal' ).modal( 'show' );
    this.action = action;
  }

  msgeSwal(type, title = '', message = '') {
    if (type === 'success') {
          swal.fire({
             
              title: title,
              text: message,
              buttonsStyling: false,
            customClass:{
    confirmButton: 'btn btn-success'
            },

          });

      } else if (type === 'error') {
        swal.fire({
        
          title: 'ERROR!',
          text: title,
          buttonsStyling: false,
         customClass:{
    confirmButton: 'btn btn-success'
            },

      });
      }
  }

  openFormModal() {
    this.holydays = new Holydays(this.identity.sub);
    $('#hdFormModal').modal('show');
  }

  closeFormModal() {
    $('#hdFormModal').modal('hide');
  }

  shorTime(time) {
    let hora = Number(time[0] + time[1]);
    let minutos = Number(time[2] + time[3]);
    let m = 'AM';
    if (hora >= 12) {
      m = 'PM';
    }
    if (hora > 12) {
      hora = hora - 12;
    }

    let horaString;
    let minutosString;

    if (hora < 10) {
      horaString = '0' + hora;
    } else {
      horaString = String(hora);
    }

    if (minutos < 10) {
      minutosString = '0' + minutos;
    } else {
      minutosString = String(minutos);
    }

    return horaString + ':' + minutosString + ' ' + m;
  }

  getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10 ) {
      day = '0' + dia;
    } else  {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10 ) {
      month = '0' + mes;
    } else  {
      month = mes;
    }
    let anio = fecha.getFullYear();

    return anio + '-' + month + '-' + day;
  }

  disponible() {
    if (this.holydays.timeOffStartDate !== '' && this.holydays.returnToWorkDate !== ''
        && (this.holydays.timeOffStartDate < this.holydays.returnToWorkDate ||
          (this.holydays.timeOffStartDate === this.holydays.returnToWorkDate
            && this.holydays.hrTimeOffStartDate < this.holydays.hrReturnToWorkDate))) {
      let json;
      json = {
        timeOffStartDate: this.holydays.timeOffStartDate,
        returnToWorkDate: this.holydays.returnToWorkDate,
        hrTimeOffStartDate: this.holydays.hrTimeOffStartDate,
        hrReturnToWorkDate: this.holydays.hrReturnToWorkDate
      };

      this.statusHolyday = null;

      this._hdServices.availability(json, this.identity.sub).subscribe(
        response => {
          console.log(response);
          this.statusHolyday = response;
        }
      );
    } else {
      this.statusHolyday = null;
    }
  }

  getHolydays() {
    this.loadingHd = true;
    this._hdServices.showAll(this.identity.sub).subscribe(
      response => {
        console.log('Holydays!!');
        console.log(response);
        if (response.status === 'success') {

          let element;
          this.holydasy = [];
          for (element of response.data) {
            this.holydasy.push(
              [
                element.id,
                this.getFecha(new Date(element.timeOffStartDate.timestamp * 1000)),
                this.shorTime(element.hrTimeOffStartDate),
                this.getFecha(new Date(element.returnToWorkDate.timestamp * 1000)),
                this.shorTime(element.hrReturnToWorkDate),
                element.reasonforLeave,
                element.approvals
              ]
            );
          }
          this.loadingHd = false;

        } else {
          this.loadingHd = false;
          /* this.mtds.notifyError(response.msg, response.code); */
        }
        this.loadingHd = false;
      }, error => {
        this.loadingHd = false;
       /*  this.mtds.notifyError(error.statusText, error.status); */
      }
    );

  }

  validhd(f) {
    if (!f.valid) return false;
    if (this.holydays.reasonforLeave === '') return false;
    if (this.holydays.timeOffStartDate > this.holydays.returnToWorkDate) return false;
    if (this.holydays.timeOffStartDate === this.holydays.returnToWorkDate && this.holydays.hrTimeOffStartDate > this.holydays.hrReturnToWorkDate) return false;
    if (this.statusHolyday.status != 'success') return false;
    if (this.savingHd) return false;

    return true;
  }

  saveHd() {
    console.log(this.holydays);
    this.savingHd = true;
    this._hdServices.create(this.holydays).subscribe(
      response => {
        console.log(response);
        if (response.status === 'success') {
          this.msgeSwal('success', 'The holidays have been added!');
          this.closeFormModal();
        /*   this.getHolydays(); */
        } else {
          this.msgeSwal('error', 'Something went wrong');
        }
        this.savingHd = false;
      }, error => {
        this.msgeSwal('error', 'Something went wrong');
        this.savingHd = false;
      }
    );
  }

   getCompanies(){
       
    
      this._companylinkedService.getAllCompaniesLite(this.token, 'all').subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
              this.companies = response.data;
                  console.log(this.companies);
          } 
        },
        error => {
          console.log(<any>error);
        }
      );
 
}


selectedFile: File;

 


     ngAfterViewInit() {

 var self = this; // get a reference to `this`






      $('.card .material-datatables label').addClass('form-group');
    }



  onSubmit(){
    console.log("do nothing");
   
  }




getManager(idusuario){
        this._userService.getUser(this.token, idusuario ).subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
              this.emailManager = response.data.email;
             this.phoneManager = response.data.phone;
              
            
          } else {
           // localStorage.clear();
            //this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );
}

  getUser(){

    this.loading = 'show';
  
      let id =this.identity.sub;
     console.log(id);
      console.log("getUser");
      this._userService.getUser(this.token, id).subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
              this.user = response.data;
              if(response.data.managedBy != ''){
                this.getManager(response.data.recommendedBy);
                this.loading = 'hide';
              }
               if(this.user.companyLinked == null){
                console.log("no hay company");
                 this.user.companyLinked["id"] = 0;
              } else {
                this.companySelected = this.user.companyLinked.id;
              }
              if(this.user.internalLocation == null){
                this.internallocationname = "";
              }else{
                this.internallocationname = this.user.internalLocation.name
              }

            /*   this.changewhloc(); */
            
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );
   
  }



	
}